export const environment = {
  production: true,

  server_url: 'https://accountdev.iagility.com',// Main app URL BE.
  angular_url: 'https://angclienttest.iagility.com',//FE URLS for redirection
  account_url: 'https://angacctest.iagility.com',//FE URLS for redirection
  admin_url: 'https://angadmintest.iagility.com',// FE URLS for redirection
  consultant_url: 'https://angconstest.iagility.com',// FE URLS for redirection
  client_url: 'https://angclienttest.iagility.com',// FE URLS for redirection
  main_url: 'https://dev.iagility.com/' // Brand Angular app URL FE./
};